import { render, staticRenderFns } from "./singleContent.vue?vue&type=template&id=afa415a2&scoped=true"
import script from "./singleContent.vue?vue&type=script&lang=ts"
export * from "./singleContent.vue?vue&type=script&lang=ts"
import style0 from "./singleContent.vue?vue&type=style&index=0&id=afa415a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa415a2",
  null
  
)

export default component.exports